const updaters = new WeakMap<HTMLElement, Updater>();

class Updater {
  private cb: () => void;
  private rO: ResizeObserver;
  private mO: MutationObserver;
  private el: HTMLElement | null = null;

  constructor(targetElement: HTMLElement) {
    this.cb = () => this.update(targetElement);
    this.rO = new ResizeObserver(this.cb);
    this.mO = new MutationObserver(() => this.on(this.el!));
    this.on(<HTMLElement>targetElement.children[0]);
  }

  on(element?: HTMLElement) {
    if (this.el) {
      this.el.removeEventListener('scroll', this.cb);
      this.rO.disconnect();
      this.mO.disconnect();
    }
    if (!element) return;
    if (
      element.nodeName === 'TABLE' &&
      !/scroll|auto/.test(
        getComputedStyle(element).getPropertyValue('overflow'),
      )
    ) {
      this.rO.observe(element);
      element = (<HTMLTableElement>element).tBodies[0];
    }
    element.addEventListener('scroll', this.cb);
    [element, ...element.children].forEach((el) => this.rO.observe(el));
    this.mO.observe(element, { childList: true });
    this.el = element;
  }

  update(targetElement: HTMLElement) {
    let cssText = `
      --t: ${this.el!.scrollTop}px;
      --b: ${this.el!.scrollHeight - this.el!.offsetHeight - this.el!.scrollTop}px;
      --l: ${this.el!.scrollLeft}px;
      --r: ${this.el!.scrollWidth - this.el!.offsetWidth - this.el!.scrollLeft}px;
    `;

    if (this.el!.nodeName === 'TBODY') {
      const clientRect = this.el!.getBoundingClientRect();
      const rootClientRect = (<HTMLTableElement>(
        this.el!.parentElement
      )).getBoundingClientRect();

      cssText += `
        top: ${clientRect.top - rootClientRect.top}px;
        bottom: ${rootClientRect.bottom - clientRect.bottom}px;
        left: ${clientRect.left - rootClientRect.left}px;
        right: ${rootClientRect.right - clientRect.right}px;
      `;
    }

    requestAnimationFrame(() => {
      targetElement.style.cssText = cssText;
    });
  }
}

export let shadow = (node: HTMLElement) => {
  updaters.set(node, new Updater(node));
  return {
    update() {
      updaters.get(node)?.on(node);
    },
    destroy() {
      updaters.get(node)?.on();
    },
  };
};
